<div class="modal-content">

    <div mat-dialog-title>
        @if(point?.id) {
        Moification d'un point
        } @else {
        Création d'un point
        }
    </div>

    <div mat-dialog-content class="modal-body">

        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="tab-icon">directions_run</mat-icon>
                    <span>Information générales</span>
                </ng-template>

                <div class="tab-content">
                    <form [formGroup]="fg">

                        <!-- Champs texte & numériques -->
                        <mat-form-field appearance="outline">
                            <mat-label>Nom</mat-label>
                            <input matInput type="text" formControlName="name" placeholder="Ex: Ravitaillement CP1">

                            @if (fg.get('name')?.hasError('required')) {
                            <mat-error>Le nom est obligatoire</mat-error>
                            }
                            @if (fg.get('name')?.hasError('maxlength')) {
                            <mat-error>100 caractères maximum</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field appearance="outline">
                            <mat-label>ID Chrono (CPID)</mat-label>
                            <input matInput type="number" formControlName="cpid">
                        </mat-form-field>

                        <div formGroupName="coordinates">
                            <mat-form-field appearance="outline">
                                <mat-label>Coordonnées (Latitude)</mat-label>
                                <input matInput type="text" formControlName="lat">
                            </mat-form-field>

                            <mat-form-field appearance="outline">
                                <mat-label>Coordonnées (Longitude)</mat-label>
                                <input matInput type="text" formControlName="lng">
                            </mat-form-field>
                        </div>



                        <hr class="form-divider" />

                        <!-- Configuration des points (Slide Toggles) -->
                        <div class="toggle-group">
                            <h3>Type de point</h3>

                            <mat-slide-toggle formControlName="isStart" color="primary">
                                Point de départ (is_start)
                            </mat-slide-toggle>

                            <mat-slide-toggle formControlName="isPrefinish" color="primary">
                                Pré-arrivée (is_prefinish)
                            </mat-slide-toggle>

                            <mat-slide-toggle formControlName="isFinish" color="primary">
                                Ligne d'arrivée (is_finish)
                            </mat-slide-toggle>

                            <mat-slide-toggle formControlName="inOut" color="primary">
                                Gestion Entrée / Sortie (in_out)
                            </mat-slide-toggle>
                        </div>

                        <hr class="form-divider" />

                        <!-- Services & Commodités (Slide Toggles) -->
                        <div class="toggle-group">
                            <h3>Services & Commodités</h3>

                            <mat-slide-toggle formControlName="refreshment" color="accent">
                                Ravitaillement
                            </mat-slide-toggle>

                            <mat-slide-toggle formControlName="toilet" color="accent">
                                Toilettes
                            </mat-slide-toggle>

                            <mat-slide-toggle formControlName="medical" color="accent">
                                Poste médical
                            </mat-slide-toggle>

                            <mat-slide-toggle formControlName="parking" color="accent">
                                Parking
                            </mat-slide-toggle>

                            <mat-slide-toggle formControlName="shower" color="accent">
                                Douches
                            </mat-slide-toggle>

                            <mat-slide-toggle formControlName="bus" color="accent">
                                Navette bus
                            </mat-slide-toggle>
                        </div>

                    </form>
                </div>

            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="tab-icon">directions_run</mat-icon>
                    <span>Courses rattachées</span>
                </ng-template>

                <!-- Contenu de l'onglet -->
                <div class="tab-content">
                    <aoe-race-linked [racePointForm]="fg"></aoe-race-linked>
                </div>
            </mat-tab>
        </mat-tab-group>


    </div>

    <div mat-dialog-actions>
        <button matButton="outlined" mat-dialog-close type="button">Annuler</button>
        <button matButton="filled" (click)="submit()" type="submit">Enregistrer</button>
    </div>

</div>